/* ==========================================================================
   Yumeka — offre après ajout au panier
   --------------------------------------------------------------------------
   Le contrat avec theme.js tient en une fonction : window.YKUpsell.proposer().
   Elle reçoit ce qui vient d'être ajouté et l'adresse où la page devait
   partir, et rend la main en promettant d'y aller — tout de suite si l'offre
   ne s'applique pas, après la décision sinon.

   Le produit demandé est DÉJÀ au panier quand la fenêtre s'ouvre. Refuser ne
   coûte donc rien et n'annule rien : la fenêtre propose, elle ne retient pas.

   Aucun montant n'est calculé ici. Les prix affichés sortent du JSON rendu par
   Liquid, donc du filtre `money` de Shopify, avec la devise et le format réels
   de la boutique.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.fetch || !window.Promise) return;

  var racine = document.querySelector('[data-upsell]');
  if (!racine) return;

  var $  = function (s, r) { return (r || racine).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || racine).querySelectorAll(s)); };

  var variantes = [];
  try { variantes = JSON.parse($('[data-upsell-json]').textContent) || []; } catch (e) { return; }
  if (!variantes.length) return;

  var declencheurs = (racine.getAttribute('data-triggers') || '').split(',').filter(Boolean);
  var formatArgent = racine.getAttribute('data-money-format') || '{{amount}}';
  var remise = parseInt(racine.getAttribute('data-discount'), 10) || 0;

  var carte    = $('[data-upsell-card]');
  var piste    = $('[data-upsell-stage]');
  var prixEl   = $('[data-upsell-price]');
  var barreEl  = $('[data-upsell-compare]');
  var gainEl   = $('[data-upsell-save]');
  var erreurEl = $('[data-upsell-error]');
  var ouiEl    = $('[data-upsell-accept]');
  /* Le libelle a son propre noeud dans le bouton : le script y ecrit « Ajout… »
     puis « Voir mon panier », et un textContent pose sur le bouton lui-meme
     emporterait tout ce qu il contiendrait un jour. Le repli sur ouiEl garde le
     script vivant si le gabarit revient a un bouton d un seul tenant. */
  var ouiLabelEl = $('[data-upsell-cta-label]') || ouiEl;
  var ecoEl    = $('[data-upsell-eco]');
  var bandeEl  = $('[data-upsell-thumbs]');
  var compteEl = $('[data-upsell-count]');
  var bandeauEl = $('[data-upsell-band]');
  var mEl = $('[data-upsell-m]');
  var sEl = $('[data-upsell-s]');
  var horloge = null;

  var destination = '/cart';
  var focusAvant = null;
  var quantite = 1;

  /* ---------- mise en forme des montants ---------------------------------- */

  /* Reprise du format de la boutique, comme dans theme.js : « 1 234,56 € » et
     non « 1234.56 ». Seuls les deux gabarits utilisés par Shopify en euros sont
     traités ; tout le reste retombe sur la valeur brute plutôt que d'inventer
     une ponctuation. */
  function argent(cents) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var entier = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var rendu = entier + ',' + parts[1];
    return formatArgent.replace(/\{\{\s*amount[^}]*\}\}/, rendu);
  }

  /* ---------- variante courante ------------------------------------------ */

  function choix() {
    return $$('[data-upsell-opt]').map(function (s) { return s.value; });
  }

  function varianteCourante() {
    var c = choix();
    return variantes.filter(function (v) {
      return c.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  }

  /* Le libelle du bouton, et lui seul. */
  function poserLibelle(txt) {
    ouiLabelEl.textContent = txt;
  }

  /* Le gain en euros. La phrase vient du gabarit, jamais d une concatenation
     ici : c est le seul texte visible de la fenetre que le script reecrit, et
     le laisser dans le HTML garde la formulation la ou on la cherche. */
  function majGain(ref, net) {
    if (!ecoEl) return;
    if (!(ref > net)) { ecoEl.hidden = true; return; }
    var tpl = ecoEl.getAttribute('data-tpl') || '{amount}';
    ecoEl.textContent = tpl.replace('{amount}', argent(ref - net));
    ecoEl.hidden = false;
  }

  function rafraichir() {
    var v = varianteCourante();

    if (!v) {
      /* Combinaison inexistante : on le dit, et on empêche l'ajout plutôt que
         de laisser partir une requête qui échouera côté serveur. */
      ouiEl.disabled = true;
      montrerErreur('Cette combinaison n’est pas disponible.');
      return;
    }

    ouiEl.disabled = !v.available || racine.classList.contains('is-expire');
    if (!v.available) montrerErreur('Ce coloris est épuisé pour le moment.');
    else cacherErreur();

    /* Même règle que dans le gabarit : avec remise, le prix barré est le prix
       courant du catalogue et le prix affiché est ce que la caisse débite. */
    var net = prixAnnonce(v);
    var ref = remise > 0 ? v.price : v.compare_at_price;

    prixEl.textContent = argent(net);

    if (ref > net) {
      barreEl.textContent = argent(ref);
      barreEl.hidden = false;
      gainEl.textContent = '\u2212' + Math.round((ref - net) * 100 / ref) + ' %';
      gainEl.hidden = false;
    } else {
      barreEl.hidden = true;
      gainEl.hidden = true;
    }
    majGain(ref, net);

    if (v.image) montrer(v.image, premierRendu);

    /* La pastille allumee et le nom affiche suivent le premier choix, qui est
       le coloris. Le nom compte autant que la pastille : une teinte deduite du
       nom du coloris est approximative par construction, et deux beiges se
       ressemblent. C est le mot qui tranche. */
    var coloris = choix()[0];
    $$('[data-upsell-swatch]').forEach(function (t) {
      t.setAttribute('aria-pressed', t.getAttribute('data-upsell-swatch') === coloris ? 'true' : 'false');
    });
    var nomEl = $('[data-upsell-color-name]');
    if (nomEl) nomEl.textContent = coloris;

    premierRendu = false;
  }

  /* Le prix que la fenêtre ANNONCE pour la variante courante. C est lui qui
     sera confronté à ce que la caisse facture, juste après l ajout. */
  function prixAnnonce(v) {
    if (!(remise > 0)) return v.price;
    return Math.round(v.price * (100 - remise) / 100);
  }

  /* Vrai tant que la fenetre n a pas encore ete peinte une premiere fois.
     Le premier rendu place la photo sans animation : la fenetre s ouvre deja
     sur la bonne, un glissement au moment de l ouverture se lirait comme un
     bug. Les suivants, eux, defilent. */
  var premierRendu = true;

  /* Fait defiler la piste jusqu a la photo demandee, et allume sa vignette.

     Ni la piste ni les vignettes ne decident quoi que ce soit : elles ne
     changent que le regard. Le coloris, le prix et ce qui partira au panier
     restent gouvernes par la liste deroulante. */
  function montrer(src, sansAnimation) {
    if (!piste) return;
    var cible = piste.querySelector('[data-upsell-slide="' + String(src).replace(/"/g, '') + '"]');
    if (cible) {
      var dx = cible.offsetLeft - piste.offsetLeft;
      var doux = !sansAnimation && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (piste.scrollTo) piste.scrollTo({ left: dx, behavior: doux ? 'smooth' : 'auto' });
      else piste.scrollLeft = dx;
    }
    allumerVignette(src);
  }

  /* Compare les adresses sans leur taille : la grande image est demandee en
     720 px de large et la vignette en 160, si bien qu une comparaison stricte
     ne reconnaitrait jamais la meme photo. On compare le nom du fichier. */
  function allumerVignette(src) {
    var nom = String(src).split('?')[0].split('/').pop();
    var actif = null;
    $$('[data-upsell-thumb]').forEach(function (b) {
      var n = String(b.getAttribute('data-upsell-thumb')).split('?')[0].split('/').pop();
      var on = n === nom;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) actif = b;
    });

    /* La vignette allumee est ramenee dans le champ de vision.

       Les coloris vivent desormais EN FIN de rangee, derriere les photos
       d argumentaire : sans ce rappel, changer de couleur allumait une vignette
       situee a huit cents pixels a droite, donc une rangee ou plus rien n est
       allume. On deplace le minimum -- juste assez pour qu elle entre -- plutot
       que de la centrer : recentrer a chaque clic ferait bouger toute la rangee
       sous le doigt. */
    if (!actif || !bandeEl) return;
    var g = actif.offsetLeft - bandeEl.offsetLeft;
    var d = g + actif.offsetWidth;
    if (g < bandeEl.scrollLeft) bandeEl.scrollLeft = g - 6;
    else if (d > bandeEl.scrollLeft + bandeEl.clientWidth) bandeEl.scrollLeft = d - bandeEl.clientWidth + 6;
  }

  /* ---------- les fleches de la rangee ------------------------------------ */

  /* La rangee a toujours defile ; rien ne le disait a la souris ni au clavier.
     Les fleches s effacent aux extremites et quand tout tient dans la largeur :
     une fleche inerte se lit comme une fleche cassee.

     Elles ne sont pas annoncees aux lecteurs d ecran -- aria-hidden dans le
     gabarit : elles ne menent nulle part ou les vignettes elles-memes ne menent
     pas, et celles-ci sont deja parcourues une a une. */
  function initFleches() {
    var prev = $('[data-upsell-thumbs-prev]');
    var next = $('[data-upsell-thumbs-next]');
    if (!bandeEl || !prev || !next) return null;

    function pas() { return Math.max(120, Math.round(bandeEl.clientWidth * 0.8)); }

    /* La tolerance est de huit pixels et non de deux. Un conteneur qui
       s accroche ne se repose jamais exactement sur zero : la marge interieure,
       les demi-pixels d une largeur fractionnaire et l arrondi du navigateur y
       laissent quelques unites. Deux pixels de marge suffisaient a faire
       apparaitre une fleche vers un vide. */
    function sync() {
      var max = bandeEl.scrollWidth - bandeEl.clientWidth;
      var deborde = max > 8;
      prev.hidden = !deborde || bandeEl.scrollLeft <= 8;
      next.hidden = !deborde || bandeEl.scrollLeft >= max - 8;
    }

    prev.addEventListener('click', function () { bandeEl.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { bandeEl.scrollBy({ left: pas(), behavior: 'smooth' }); });
    bandeEl.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    return sync;
  }

  /* Mesuree a l ouverture, jamais au chargement : la fenetre est masquee tant
     qu elle n a pas ete demandee, et une largeur mesuree sur un element masque
     vaut zero -- les deux fleches se seraient cachees pour toujours. */
  var syncFleches = initFleches();

  function montrerErreur(msg) { erreurEl.textContent = msg; erreurEl.hidden = false; }
  function cacherErreur() { erreurEl.textContent = ''; erreurEl.hidden = true; }

  /* ---------- le decompte ------------------------------------------------- */

  /* Il est vrai, et c est la seule raison pour laquelle il existe.

     A zero, l offre se FERME : le bouton se desactive, le bandeau change, et
     la fenetre part vers la destination prevue apres une seconde de lecture.
     Le refus est enregistre au meme titre qu un refus explicite, donc la
     fenetre ne revient pas de la session et le compteur ne recommence jamais.

     performance.now() plutot que Date.now() : on compte des millisecondes
     ecoulees depuis l ouverture, pas une heure. Une horloge systeme dereglee
     n a donc aucun effet, et il n y a rien a ranger dans le navigateur.

     Ce que le compteur ne pretend pas : reserver un stock. Il n en reserve
     aucun, et le texte du bandeau ne dit pas le contraire. */
  function lancerDecompte() {
    /* La duree est relue A L OUVERTURE, pas au chargement du script : le
       reglage peut changer sous l oeil de l editeur de theme, et la fenetre
       doit alors montrer la nouvelle valeur sans recharger la page. */
    var secondes = parseInt(racine.getAttribute('data-seconds'), 10) || 0;
    if (!(secondes > 0) || !mEl || !sEl) return;
    var depart = performance.now();
    horloge = setInterval(function () {
      var reste = Math.max(0, Math.round(secondes - (performance.now() - depart) / 1000));
      mEl.textContent = ('0' + Math.floor(reste / 60)).slice(-2);
      sEl.textContent = ('0' + (reste % 60)).slice(-2);
      if (reste <= 0) expirer();
    }, 250);
  }

  function arreterDecompte() {
    if (horloge) { clearInterval(horloge); horloge = null; }
  }

  function expirer() {
    arreterDecompte();
    racine.classList.add('is-expire');
    ouiEl.disabled = true;
    /* La phrase porte son propre element : viser firstChild attrapait l icone
       depuis qu il y en a une. */
    var phraseEl = $('[data-upsell-phrase]');
    if (phraseEl) phraseEl.textContent = 'Cette offre vient de se terminer.';
    /* Une seconde pour lire ce qui vient de se passer, puis on repart. Partir
       sans un mot donnerait l impression d un bug. */
    setTimeout(refuser, 1200);
  }

  /* ---------- ouverture, fermeture --------------------------------------- */

  function ouvrir() {
    focusAvant = document.activeElement;
    racine.hidden = false;
    document.body.style.overflow = 'hidden';
    if (syncFleches) {
      syncFleches();
      if (window.requestAnimationFrame) window.requestAnimationFrame(syncFleches);
    }
    quantite = 1;
    compteEl.textContent = '1';
    rafraichir();
    /* La carte s ouvre EN HAUT, et le focus ne descend pas la chercher.

       Le focus allait au premier menu, celui du coloris — devenu invisible
       depuis que les pastilles le pilotent. Le navigateur faisait defiler la
       carte jusqu a lui, et sur mobile la fenetre s ouvrait donc au milieu
       d elle-meme : titre a -408 px, decompte a -217, tout le haut hors
       ecran. Mesure sur la boutique, a 375 px.

       Le focus va donc a la carte, qui porte le role de dialogue. La lecture
       commence par le titre, comme sur ordinateur, et le piege a focus
       continue de retenir la tabulation. */
    if (carte) { carte.scrollTop = 0; carte.focus(); }
    lancerDecompte();
    document.addEventListener('keydown', auClavier);
  }

  function partir() {
    arreterDecompte();
    document.removeEventListener('keydown', auClavier);
    document.body.style.overflow = '';
    if (focusAvant && focusAvant.focus) focusAvant.focus();
    /* La fenetre se ferme AVANT de partir. Le navigateur garde la fiche en
       memoire (bfcache) : sur telephone, la croix du tiroir panier fait
       « retour », et la fiche revenait avec la fenetre encore ouverte. Croix
       de la fenetre -> panier -> croix du tiroir -> fenetre : une boucle. */
    racine.hidden = true;
    window.location.href = destination;
  }

  /* Ceinture et bretelles : une fiche restauree depuis le cache ne montre
     jamais la fenetre, quel que soit l etat ou elle a ete quittee. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || racine.hidden) return;
    arreterDecompte();
    document.removeEventListener('keydown', auClavier);
    racine.hidden = true;
    document.body.style.overflow = '';
  });

  /* Refuser mene au PANIER, comme accepter. La destination ne se deduit pas du
     champ return_to du formulaire, qui varie selon le reglage d achat direct de
     la fiche : elle est la meme pour toutes les sorties de cette fenetre --
     refus, croix, echappement, decompte expire.

     Le panier a ete supprime de ce parcours une version durant, au nom du
     nombre d ecrans. La clientele de la boutique a tranche l inverse : ce sont
     des dames d un certain age, et les envoyer d un clic sur un formulaire de
     paiement, sans avoir montre ce qu elles emportent ni ce qui leur est
     offert, va trop vite. Le panier est l ecran ou l on verifie avant de payer,
     et c est aussi le seul qui presente les taies offertes.

     Un ecran de plus avant le paiement, donc, et assume : une commande qu on ne
     comprend pas est une commande qu on n envoie pas. */
  function refuser() {
    destination = '/cart';
    partir();
  }

  function auClavier(e) {
    if (e.key === 'Escape') { e.preventDefault(); refuser(); return; }
    if (e.key !== 'Tab') return;
    /* Piège à focus : une fenêtre modale qui laisse tabuler vers la page
       derrière n'est modale que pour la souris. */
    var cibles = $$('button, select, [href], input', carte).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!cibles.length) return;
    var premier = cibles[0], dernier = cibles[cibles.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  /* ---------- décision --------------------------------------------------- */

  function accepter() {
    var v = varianteCourante();
    if (!v || !v.available) return;
    var attendu = prixAnnonce(v);
    ouiEl.disabled = true;
    poserLibelle('Ajout…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: quantite }] })
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var b = null;
          try { b = JSON.parse(t); } catch (e) { throw new Error('Le panier n’a pas répondu (' + r.status + ').'); }
          if (!r.ok) throw new Error(b.description || b.message || 'Ajout impossible.');
          return b;
        });
      })
      /* ANNONCÉ CONTRE FACTURÉ.

         Une remise automatique ne se calcule qu au panier : Liquid ne la voit
         pas sur une fiche produit, et la fenêtre a donc affiché un prix déduit
         d un pourcentage. Si la remise Shopify est modifiée, expirée, ou ne vise
         pas ce produit, ce pourcentage devient un mensonge — c est exactement la
         panne de fin août, un montant annoncé et un autre débité.

         On relit donc le panier et on compare. En cas d écart, on ne pousse pas
         vers la caisse : on annonce le prix réel et on renvoie au panier, seul
         écran où les montants viennent tous du serveur. La tolérance d un
         centime absorbe les arrondis.

         L ajout, lui, n est jamais annulé : la cliente a cliqué, le produit est
         à elle. C est le prix qu on corrige, pas sa décision. */
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (panier) {
        var ligne = panier && panier.items.filter(function (it) {
          return String(it.variant_id) === String(v.id);
        })[0];
        if (ligne && Math.abs(ligne.final_price - attendu) > 1) {
          destination = '/cart';
          montrerErreur('Le prix appliqué est ' + argent(ligne.final_price) + ', et non ' + argent(attendu) + '. Vérifiez votre panier avant de payer.');
          ouiEl.disabled = false;
          poserLibelle('Voir mon panier');
          ouiEl.removeEventListener('click', accepter);
          ouiEl.addEventListener('click', partir);
          arreterDecompte();
          return;
        }
        /* Accepter mene au PANIER, comme refuser. La cliente vient d ajouter
           deux articles en deux gestes, dont un lot avec ses cadeaux : le
           panier est l ecran ou elle les voit reunis, avec leurs coloris et
           leur total, avant d entrer la moindre coordonnee bancaire. */
        destination = '/cart';
        partir();
      })
      .catch(function (e) {
        ouiEl.disabled = false;
        poserLibelle(ouiEl.getAttribute('data-libelle') || 'Ajouter à ma commande');
        montrerErreur(e.message);
      });
  }

  /* ---------- écouteurs --------------------------------------------------- */

  ouiEl.setAttribute('data-libelle', ouiLabelEl.textContent.trim());
  ouiEl.addEventListener('click', accepter);
  $$('[data-upsell-decline]').forEach(function (b) { b.addEventListener('click', refuser); });
  $$('[data-upsell-opt]').forEach(function (s) { s.addEventListener('change', rafraichir); });

  /* Les vignettes ne changent que le regard : elles posent la grande image et
     ne touchent ni au coloris, ni au prix, ni a ce qui partira au panier. C est
     pourquoi elles ne rafraichissent rien — rafraichir remettrait l image de la
     variante et annulerait le clic dans la seconde.

     Elles suivent en revanche le coloris : quand la variante change, sa photo
     devient la grande image, et c est cette vignette-la qui s allume. */
  /* Le glissement change la vignette allumee.

     On attend l arret du defilement plutot que de recalculer a chaque pixel :
     la piste s accroche, et la seule photo qui compte est celle sur laquelle
     elle s arrete. Recalculer en continu ferait clignoter l anneau pendant
     tout le geste. */
  if (piste) {
    var minuteurDefil = null;
    piste.addEventListener('scroll', function () {
      if (minuteurDefil) clearTimeout(minuteurDefil);
      minuteurDefil = setTimeout(function () {
        var x = piste.scrollLeft;
        var proche = null, ecart = Infinity;
        $$('[data-upsell-slide]', piste).forEach(function (dia) {
          var ecart2 = Math.abs((dia.offsetLeft - piste.offsetLeft) - x);
          if (ecart2 < ecart) { ecart = ecart2; proche = dia; }
        });
        if (proche) allumerVignette(proche.getAttribute('data-upsell-slide'));
      }, 120);
    }, { passive: true });
  }

  $$('[data-upsell-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var src = b.getAttribute('data-upsell-thumb');
      if (!src) return;
      montrer(src, false);
    });
  });

  /* Les pastilles ne sont qu une facon de regarder la liste deroulante : elles
     posent sa valeur puis la laissent faire le reste. Un seul chemin de
     decision, donc aucun risque de voir la pastille et le prix se contredire. */
  $$('[data-upsell-swatch]').forEach(function (t) {
    t.addEventListener('click', function () {
      var premier = $('[data-upsell-opt="0"]');
      if (!premier) return;
      premier.value = t.getAttribute('data-upsell-swatch');
      rafraichir();
    });
  });

  $$('[data-upsell-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      quantite = Math.max(1, Math.min(10, quantite + Number(b.getAttribute('data-upsell-step'))));
      compteEl.textContent = String(quantite);
    });
  });

  /* ---------- le contrat avec theme.js ------------------------------------ */

  window.YKUpsell = {
    /* Renvoie true si la fenêtre prend la main — theme.js ne redirige alors
       pas. Renvoie false dans tous les autres cas, y compris en cas de doute :
       une offre ratée coûte une vente en plus, une redirection ratée coûte la
       vente tout court. */
    proposer: function (items, route) {
      try {
        if (!items || !items.length) return false;

        /* L'offre ne se déclenche que sur les produits désignés. */
        var declenche = items.some(function (it) {
          return declencheurs.indexOf(String(it.id)) !== -1;
        });
        if (!declenche) return false;

        /* La destination ne depend pas du formulaire. Elle est la meme pour
           toutes les sorties : le panier. Le parametre reste dans la signature
           parce que theme.js le passe, et parce qu il redeviendra utile le jour
           ou l offre devra revenir la ou la cliente etait. */
        destination = '/cart';

        /* Le propriétaire souhaite reproposer l'offre après chaque ajout
           Nuage ou Align, y compris si une Yumora est déjà dans le panier. */
        ouvrir();

        return true;
      } catch (e) {
        return false;
      }
    }
  };
})();
